export default {"src":"https://fishbrain.com/_next/static/media/georgia.1e249565.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};